<template>
  <div>
    <div
      v-if="requestQuery.pageFrom != 'auditDetail' && !isTableGreyFeatures"
      class="card"
    >
      <div class="section">
        <div class="section-title">
          <base-section-title title="成交结果" />
        </div>
        <div class="section-content">
          <jczh-table-content :data="winnerNoticeList" :option="listOptions">
            <template v-slot:bidAmount="{ row }">
              {{ row.bidAmount ? strToThousands(row.bidAmount) : '-' }}
              <money-in-cn
                v-if="!isDollar"
                :money="row.bidAmount"
                :ellipsis="false"
              />
            </template>
            <template v-slot:operate="{ row }">
              <el-button type="text" @click="downloadFile(row)">
                下载
              </el-button>
            </template>
          </jczh-table-content>
        </div>
      </div>
    </div>
    <!-- 成交供应商信息表格 -->
    <div class="card">
      <!--五菱的成交展示-->
      <div v-if="isTableGreyFeatures" key="wuling" class="section">
        <div class="section-title">
          <base-section-title title="成交供应商" />
        </div>

        <div class="section-content">
          <el-form v-if="awardMethodInfo" class="detail-form m-b-24">
            <el-form-item label="授标方式：">
              <span>{{ awardMethodInfo.label || '-' }}</span>
            </el-form-item>
            <el-form-item label="授标方式说明：">
              <span>{{ awardMethodInfo.desc || '-' }}</span>
            </el-form-item>
          </el-form>

          <award-sheet
            :is-wuling="true"
            :table-data="tableData"
            :is-dollar="isDollar"
            :span-num-obj="getNumOfEachMaterial()"
            :require-tax="requireTax"
            :is-show-total="true"
            :budget-total-amt="winnerInfo.budgetTotalAmt"
            :winner-total-amt="winnerInfo.winnerTotalAmt"
          />

          <el-form class="detail-form m-t-24" label-suffix="：">
            <el-form-item label="上传记录或其他文件">
              <upload
                v-if="winnerInfo.winnerAttachmentIds"
                :file-id-before.sync="winnerInfo.winnerAttachmentIds"
                :props-data="{
                  disabled: true,
                  uploadMode: 'fileId',
                  singleUpload: false
                }"
              />
              <span v-else>-</span>
            </el-form-item>
            <el-form-item label="备注">
              <span>{{ winnerInfo.remark || '-' }}</span>
            </el-form-item>
          </el-form>
        </div>

        <div v-if="isShowModifyInfo" class="m-t-20">
          <div class="section-title">
            <base-section-title title="修改成交供应商原因" />
          </div>
          <div class="section-content">
            <el-row>
              <el-col :xs="24" :sm="24" :md="20" :lg="14" :xl="10">
                <el-form
                  label-width="100px"
                  class="detail-form"
                  label-suffix="："
                >
                  <el-form-item label="上传附件">
                    <upload
                      v-if="winnerInfo.changeWinnerAttachmentIds"
                      :props-data="{
                        disabled: true,
                        fileIdBefore: winnerInfo.changeWinnerAttachmentIds,
                        uploadMode: 'fileId',
                        singleUpload: true
                      }"
                    />
                    <span v-else>-</span>
                  </el-form-item>

                  <el-form-item label="备注">
                    <span>{{ winnerInfo.changeRemark || '-' }}</span>
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <!--默认平台的成交展示-->
      <div v-else key="default" class="section">
        <div class="section-title">
          <base-section-title title="成交供应商">
            <template v-slot:right-tool>
              <el-button
                type="primary"
                size="medium"
                class="flex-center m-b-10"
                @click="exportWinnerResult"
              >
                导出pdf
              </el-button>
            </template>
          </base-section-title>
        </div>
        <div class="section-content">
          <purchase-list-award
            :table-data="tableData"
            :item-schema-list="itemSchemaList"
            :require-tax="requireTax"
            :pdf-api="getInquiryWinnerAwardPdf"
            :is-dollar="isDollar"
            :show-title="false"
            title="成交供应商"
            pdf-name="询比成交表"
            :span-num-obj="getNumOfEachMaterial()"
          />

          <el-form class="detail-form m-t-24" label-suffix="：">
            <el-form-item label="上传记录或其他文件">
              <upload
                v-if="winnerInfo.winnerAttachmentIds"
                :file-id-before.sync="winnerInfo.winnerAttachmentIds"
                :props-data="{
                  disabled: true,
                  uploadMode: 'fileId',
                  singleUpload: false
                }"
              />
              <span v-else>-</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <!--五菱的灰度信息展示-->
    <template v-if="isTableGreyFeatures">
      <div class="card">
        <div class="section">
          <base-section-title class="section-title" title="供应商报价比价单" />

          <div class="section-content">
            <compare-sheet
              :table-data="offerTableData"
              :header-list="offerHeaderList"
              :round-id="roundId"
              :is-dollar="isDollar"
              :span-num="offerSpanNum"
              :require-tax="requireTax"
              :is-operate="false"
              :invite-supplier-list="inviteSupplierList"
            />
          </div>
        </div>
      </div>

      <div class="card">
        <div class="section">
          <base-section-title class="section-title" title="议价" />
          <div class="section-content">
            <bargain-sheet :form="winnerInfo" :is-dollar="isDollar" disabled />
          </div>
        </div>
      </div>

      <div class="card">
        <div class="section">
          <base-section-title class="section-title" title="内部附件上传" />

          <div class="section-content">
            <el-form class="detail-form m-t-24" label-suffix="：">
              <el-form-item label="内部附件上传">
                <upload
                  v-if="internalAttachmentIds && internalAttachmentIds.length"
                  :file-id-before="internalAttachmentIds"
                  :props-data="{
                    disabled: true,
                    uploadMode: 'fileId'
                  }"
                />
                <span v-else>-</span>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </template>

    <div v-if="isServiceFeeSetting" class="card">
      <div class="section">
        <base-section-title class="section-title" title="平台服务费" />
        <el-form label-width="120px" class="detail-form" label-suffix="：">
          <el-form-item label="平台服务费">
            {{ winnerInfo.winServiceFee || 0 }} 元
            <money-in-cn
              v-if="winnerInfo.winServiceFee"
              :money="winnerInfo.winServiceFee"
            />
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 成交信息公告 -->
    <div class="card m-t-20">
      <div class="section">
        <div class="section-title">
          <base-section-title title="成交供应商结果公告" />
        </div>
        <div class="section-content">
          <el-row>
            <el-col :xs="24" :sm="24" :md="20" :lg="14" :xl="10">
              <el-form
                ref="bulletinForm"
                label-width="100px"
                class="detail-form"
                label-suffix="："
              >
                <el-form-item label="发布日期">
                  <span>
                    {{ winnerInfo.noticePublishTime | getNormDayFilter }}
                  </span>
                </el-form-item>
                <el-form-item label="发布状态">
                  <el-tag
                    :type="
                      noticeReleaseStatusDict.translate(
                        winnerInfo.noticeReleaseStatus
                      ).type
                    "
                    size="small"
                  >
                    {{
                      noticeReleaseStatusDict.translate(
                        winnerInfo.noticeReleaseStatus
                      ).label || '-'
                    }}
                  </el-tag>
                </el-form-item>
                <el-form-item label="发布公告">
                  <content-item
                    :value="
                      inquiryWhetherToPublishDict.translate(
                        winnerInfo.publicity
                      ).label
                    "
                  />
                </el-form-item>
                <el-form-item
                  v-if="winnerInfo.noticeTitle"
                  label="公告标题"
                  prop="noticeTitle"
                >
                  <content-item :value="winnerInfo.noticeTitle" />
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-form
            v-if="winnerInfo.noticeTitle"
            ref="editorForm"
            class="detail-form"
          >
            <el-form-item>
              <u-editor v-model="winnerInfo.noticeContent" disabled />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import AwardSheet from '@/components/inquiry/AwardSheet'
import PurchaseListAward from '@/components/common/PurchaseListComponent/PurchaseListAward'
import ContentItem from '@/components/common/ContentItem'
import UEditor from '@/components/common/UEditor/index.vue'
import Upload from '@/components/common/Upload/index'
import CompareSheet from '@/components/inquiry/CompareSheet'
import BargainSheet from '@/components/inquiry/BargainSheet.vue'
import MoneyInCn from '@/components/common/MoneyInCn'

import {
  getInquiryWinnerAwardPdfApi,
  getInquiryOfferComparePdfApi
} from '@/api/procure/inquiry'
import { getInquiryWinnerNoticeFileApi } from '@/api/download'

import {
  inquiryWhetherToPublishDict,
  awardMethodDict,
  sortTypeDict
} from '@/dictionary/project/inquiry'
import {
  noticeReleaseStatusDict,
  whetherDict
} from '@/dictionary/project/common'
import { countRepeatNum, strToThousands } from '@/utils/utils'
import { mapActions } from 'vuex'

import { watermarkTypeDict } from '@/dictionary/template'
import { getFileUrlByFileIdApi, htmlToPdfApi } from '@/api/up-file'
import { generateResultHtml } from '@/components/common/PurchaseListComponent/generate-winner-html'

export default {
  name: 'OrderWinnerTemplate',

  components: {
    BaseSectionTitle,
    AwardSheet,
    PurchaseListAward,
    ContentItem,
    UEditor,
    Upload,
    CompareSheet,
    BargainSheet,
    MoneyInCn
  },

  props: {
    tableData: {
      type: Array,
      required: true
    },

    // 结果公告信息
    winnerInfo: {
      type: Object,
      required: true
    },

    // 是否含税
    requireTax: {
      type: Boolean,
      required: true
    },

    // 字段设置
    itemSchemaList: {
      type: Array,
      default: () => []
    },

    winnerId: {
      type: [String, Number],
      default: ''
    },

    isDollar: {
      type: Boolean,
      default: false
    },

    roundId: {
      type: [Number, String],
      default: ''
    },

    /**
     * 是否展示修改供应商原因信息
     */
    isShowModifyInfo: {
      type: Boolean,
      default: false
    },

    // 内部附件
    internalAttachmentIds: {
      type: [Array, String],
      default: ''
    },

    isTableGreyFeatures: {
      type: Boolean,
      default: false
    },

    orderId: {
      type: [Number, String],
      default: 0
    },

    // 成交结果
    winnerNoticeList: {
      type: Array,
      default: () => []
    },

    // 判断成交结果列表是否展示
    requestQuery: {
      type: Object,
      default: () => {
        return {
          pageFrom: ''
        }
      }
    },

    inviteSupplierList: {
      type: Array,
      default: () => []
    },

    // 平台服务费是否发布设置
    isServiceFeeSetting: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      // 信息列表中各品目需要跨越的行
      // spanNumObj: {},
      inquiryWhetherToPublishDict,
      noticeReleaseStatusDict,
      whetherDict,

      // 供应商比价单
      offerTableData: [],
      offerHeaderList: [],
      offerSpanNum: 1,
      // 排序方式
      sortType: sortTypeDict.OFFER_PRICE_ASC.value
    }
  },

  computed: {
    showBulletin() {
      return this.winnerInfo.publicity === inquiryWhetherToPublishDict.YES.value
    },

    /**
     * 一键选择授标方式
     */
    awardMethodInfo() {
      return this.winnerInfo.awardType
        ? awardMethodDict.translate(this.winnerInfo.awardType)
        : null
    },

    listOptions() {
      if (this.isDollar) {
        return [
          { label: '成交供应商', prop: 'supplierName' },
          {
            label: '成交金额(美元)',
            slotName: 'bidAmount'
          },
          { label: '成交结果通知书', slotName: 'operate' }
        ]
      } else {
        return [
          { label: '成交供应商', prop: 'supplierName' },
          {
            label: '成交金额(元)',
            slotName: 'bidAmount'
          },
          { label: '成交结果通知书', slotName: 'operate' }
        ]
      }
    }
  },

  watch: {
    // 五菱
    isTableGreyFeatures: {
      handler(val) {
        if (val) {
          this.fetchWulingRoundPriceCompare()
        }
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions('company', ['showGreyFeature']),
    strToThousands,

    // 获取每批品目成交供应商数量
    getNumOfEachMaterial() {
      const tempList = this.tableData || []
      return countRepeatNum(tempList, 'materielId')
    },

    // 五菱-请求当前轮次的比价信息
    fetchWulingRoundPriceCompare() {
      getInquiryOfferComparePdfApi(
        this.orderId,
        this.roundId,
        JSON.parse(this.sortType)
      )
        .then(res => {
          const data = res?.data || {}
          const compareInfo = (data.roundCompareList || []).find(
            item => item.roundId == this.roundId
          )

          this.offerHeaderList = compareInfo?.allOfferList || []
          this.offerTableData = (compareInfo?.itemCompareList || []).map(
            (item, index) => {
              const { supplierCompareList = [], materiel, ...other } = item

              const offerValue = {}
              supplierCompareList.forEach(supplier => {
                offerValue[supplier.supplierId] = { ...supplier }
              })

              return {
                ...other,
                ...materiel,
                offerValue
              }
            }
          )
          this.offerSpanNum = 1
        })
        .catch(err => {
          this.$message.error(err.message || '获取比价信息失败')
        })
    },

    /**
     * 获取pdf数据
     */
    getInquiryWinnerAwardPdf() {
      return new Promise((resolve, reject) => {
        getInquiryWinnerAwardPdfApi(
          this.orderId || this.$route.params.orderId,
          this.winnerId
        )
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 获取比价表pdf数据
    getPdfData() {
      return new Promise((resolve, reject) => {
        this.getInquiryWinnerAwardPdf()
          .then(res => {
            const data = res?.data || {}
            resolve(data)
          })
          .catch(err => {
            if (err?.message) this.$message.error(err.message)
            throw err
          })
      })
    },

    // 下载pdf
    async exportWinnerResult() {
      const pdfData = await this.getPdfData()
      const tableHtml = generateResultHtml({
        pdfData,
        pdfTitle: '询比成交表',
        isDollar: this.isDollar
      })
      this.downloadPdf(tableHtml)
    },

    // 下载pdf
    downloadPdf(content) {
      const postData = {
        name: `询比成交表.pdf`,
        watermark: {
          watermarkType: watermarkTypeDict.ORDINARY_TEXT.value, // 水印类型
          watermarkWord: '精彩纵横云采购平台'
        },
        content: content
      }
      htmlToPdfApi(postData)
        .then(res => {
          getFileUrlByFileIdApi({ attachmentId: res.data }).then(fileRes => {
            window.open(fileRes.data.external, '_self')
          })
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
          throw err
        })
    },

    // 下载
    downloadFile(row) {
      const ids = {
        orderId: this.orderId,
        tradeId: row.tradeId,
        winnerId: this.winnerId
      }
      getInquiryWinnerNoticeFileApi(ids)
    }
  }
}
</script>

<style scoped></style>
